import { Box, theme, Typography, UnorderedList } from '@fe-toolkit/web-components'

const LearnMoreAboutOutsideInstallModalContent = () => {
  return (
    <Box>
      <Typography as="h2" sx={{ marginBottom: theme.spacing.small }} variant="louder">
        Outside install
      </Typography>

      <Typography as="p" sx={{ marginBottom: theme.spacing.small, fontWeight: '300' }} variant="speak">
        This takes the fibre cable from the street to your home for that literal speed of light connection.
      </Typography>

      <UnorderedList withBullets>
        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          The engineers will come by and bring the fibre cable from the street to your house. Either through existing
          ducts or by laying a new cable.
        </Typography>

        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          The fibre can either come from overhead via a telegraph pole or underground via a pipe depending on the setup
          in your street. If you’d like to know which type you’ll have, please reach out to us.
        </Typography>

        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          Depending on the arrangement on your street, there will be a little disruption to get the install done. There
          will be some drilling to get things hooked up to the wall, and possibly some digging for cables laid
          underground.
        </Typography>

        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          If you'd like your router in a specific spot inside your home let us know in the notes. Or speak to the expert
          engineers on the day so they can bring the cable as close as possible on the outside of your home.
        </Typography>

        <Typography as="li" sx={{ fontWeight: '300' }} variant="speak">
          If the engineers will need special access or you have an unusual type of garden, let them know in the notes.
        </Typography>
      </UnorderedList>
    </Box>
  )
}

export default LearnMoreAboutOutsideInstallModalContent
